"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let TransactionNotesEditor = class TransactionNotesEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    getItems(...args) {
        const value = this.value;
        if (this._items && value === this._items) {
            return this._items;
        }
        if (value == null || value.length == 0) {
            this._items = [];
            return this._items;
        }
        this._items = value;
        return value;
    }
    addItem(...args) {
        this.items.push(this.newItem());
        this.emitChange();
    }
    newItem(...args) {
        return {
            message: null,
            valid_from: null,
            valid_to: null,
            counter: null,
            max_displays: null,
        };
    }
    removeItem(...args) {
        const [item] = args;
        const removed = _.remove(this._items, p => p === item);
        if (removed && removed.length) {
            this.emitChange();
        }
    }
    emitChange(...args) {
        this._items = this.items.slice();
        this.items = this._items;
        this.$emit('input', this._items);
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    disabled;
    onDisabled(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("disabled");
    }
    items;
    async $$load_items() {
        return this.getItems();
    }
    ux;
    dataMembers = ['items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
            },
        };
    }
    async act_5534025912102772_script_2542_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_5534025912102772_script_2542_getActionArgs($event) {
        return {
            value: () => this.act_5534025912102772_script_2542_getActionArgs_value($event),
        };
    }
    async evh_5534025912102772_input(event, scope) {
        return await this.actions.evh_5534025912102772_input.executeFromDOM(this, event, scope);
    }
    async act_309515315410323_script_2544_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_309515315410323_script_2544_getActionArgs($event) {
        return {
            value: () => this.act_309515315410323_script_2544_getActionArgs_value($event),
        };
    }
    async evh_309515315410323_input(event, scope) {
        return await this.actions.evh_309515315410323_input.executeFromDOM(this, event, scope);
    }
    async act_5188750589197515_script_2546_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_5188750589197515_script_2546_getActionArgs($event) {
        return {
            value: () => this.act_5188750589197515_script_2546_getActionArgs_value($event),
        };
    }
    async evh_5188750589197515_input(event, scope) {
        return await this.actions.evh_5188750589197515_input.executeFromDOM(this, event, scope);
    }
    async act_3475726502813997_script_2548_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_3475726502813997_script_2548_getActionArgs($event) {
        return {
            value: () => this.act_3475726502813997_script_2548_getActionArgs_value($event),
        };
    }
    async evh_3475726502813997_input(event, scope) {
        return await this.actions.evh_3475726502813997_input.executeFromDOM(this, event, scope);
    }
    async act_4449693688767071_script_2550_getActionArgs_value($event) {
        this.emitChange();
    }
    async act_4449693688767071_script_2550_getActionArgs($event) {
        return {
            value: () => this.act_4449693688767071_script_2550_getActionArgs_value($event),
        };
    }
    async evh_4449693688767071_input(event, scope) {
        return await this.actions.evh_4449693688767071_input.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_script_2552_getActionArgs_value($event) {
        this.removeItem($event.scope.item);
    }
    async act_1548630417156826_script_2552_getActionArgs($event) {
        return {
            value: () => this.act_1548630417156826_script_2552_getActionArgs_value($event),
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_96700093353179_script_2554_getActionArgs_value($event) {
        this.addItem();
    }
    async act_96700093353179_script_2554_getActionArgs($event) {
        return {
            value: () => this.act_96700093353179_script_2554_getActionArgs_value($event),
        };
    }
    async evh_96700093353179_clickPreventStop(event, scope) {
        return await this.actions.evh_96700093353179_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5534025912102772_script_2542 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5534025912102772_script_2542_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_input_2541 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_script_2542,
            event: "input",
            displayName: "script",
        });
        const evh_5534025912102772_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_input_2541],
        });
        const act_309515315410323_script_2544 = new core_1.actions.ScriptAction({
            actionArgs: this.act_309515315410323_script_2544_getActionArgs,
            events: [],
        });
        const evh_309515315410323_input_2543 = new core_1.actions.EventHandlerImpl({
            action: act_309515315410323_script_2544,
            event: "input",
            displayName: "script",
        });
        const evh_309515315410323_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_309515315410323_input_2543],
        });
        const act_5188750589197515_script_2546 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5188750589197515_script_2546_getActionArgs,
            events: [],
        });
        const evh_5188750589197515_input_2545 = new core_1.actions.EventHandlerImpl({
            action: act_5188750589197515_script_2546,
            event: "input",
            displayName: "script",
        });
        const evh_5188750589197515_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5188750589197515_input_2545],
        });
        const act_3475726502813997_script_2548 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3475726502813997_script_2548_getActionArgs,
            events: [],
        });
        const evh_3475726502813997_input_2547 = new core_1.actions.EventHandlerImpl({
            action: act_3475726502813997_script_2548,
            event: "input",
            displayName: "script",
        });
        const evh_3475726502813997_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3475726502813997_input_2547],
        });
        const act_4449693688767071_script_2550 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4449693688767071_script_2550_getActionArgs,
            events: [],
        });
        const evh_4449693688767071_input_2549 = new core_1.actions.EventHandlerImpl({
            action: act_4449693688767071_script_2550,
            event: "input",
            displayName: "script",
        });
        const evh_4449693688767071_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4449693688767071_input_2549],
        });
        const act_1548630417156826_script_2552 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1548630417156826_script_2552_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_2551 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_script_2552,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_2551],
        });
        const act_96700093353179_script_2554 = new core_1.actions.ScriptAction({
            actionArgs: this.act_96700093353179_script_2554_getActionArgs,
            displayName: "addItem",
            events: [],
        });
        const evh_96700093353179_clickPreventStop_2553 = new core_1.actions.EventHandlerImpl({
            action: act_96700093353179_script_2554,
            event: "click.prevent.stop",
            displayName: "addItem",
        });
        const evh_96700093353179_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_96700093353179_clickPreventStop_2553],
        });
        return {
            act_5534025912102772_script_2542,
            evh_5534025912102772_input_2541,
            evh_5534025912102772_input,
            act_309515315410323_script_2544,
            evh_309515315410323_input_2543,
            evh_309515315410323_input,
            act_5188750589197515_script_2546,
            evh_5188750589197515_input_2545,
            evh_5188750589197515_input,
            act_3475726502813997_script_2548,
            evh_3475726502813997_input_2547,
            evh_3475726502813997_input,
            act_4449693688767071_script_2550,
            evh_4449693688767071_input_2549,
            evh_4449693688767071_input,
            act_1548630417156826_script_2552,
            evh_1548630417156826_clickPreventStop_2551,
            evh_1548630417156826_clickPreventStop,
            act_96700093353179_script_2554,
            evh_96700093353179_clickPreventStop_2553,
            evh_96700093353179_clickPreventStop,
            addItem: act_96700093353179_script_2554,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], TransactionNotesEditor.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TransactionNotesEditor.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], TransactionNotesEditor.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TransactionNotesEditor.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], TransactionNotesEditor.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TransactionNotesEditor.prototype, "onReadonly", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], TransactionNotesEditor.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TransactionNotesEditor.prototype, "onDisabled", null);
TransactionNotesEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], TransactionNotesEditor);
exports.default = TransactionNotesEditor;
vue_property_decorator_1.Vue.component("TransactionNotesEditor", TransactionNotesEditor);
